// Shared helpers for CRM leads (statuses, labels, styles)
export const LEAD_STATUSES = ["novo", "contactado", "proposta", "fechado", "perdido"];

export const LEAD_STATUS_LABELS = {
    novo: "Novo",
    contactado: "Contactado",
    proposta: "Proposta",
    fechado: "Fechado",
    perdido: "Perdido",
};

export const LEAD_STATUS_STYLES = {
    novo: "bg-brand-orange-soft text-brand-orange",
    contactado: "bg-blue-100 text-blue-700",
    proposta: "bg-brand-yellow text-[#8a6b00]",
    fechado: "bg-brand-green text-white",
    perdido: "bg-gray-200 text-gray-600",
};
